import { Box, Typography } from '@mui/material';
import React from 'react';
import {
   ExamplesDataType,
   ExamplesType,
   CharityExampleType,
   GeneralExampleType,
   AmountExampleType,
   CauseExampleType,
   MessageActionStatusType,
} from 'store/bonoBot/types';
import { CauseType } from 'store/causes/types';
import { bonoBotState } from 'store/bonoBot/bonoBot.slice';
import { useAppSelector } from 'store/hooks';
import ExampleContainer from './ExampleContainer';
import GeneralExample from './GeneralExample';
import CauseExample from './CauseExample';
import CharityExample from './CharityExample';
import AmountExample from './AmountExample';

interface IExamplesProps {
   type: ExamplesType;
   examples: ExamplesDataType;
   status?: MessageActionStatusType;
   isLastMessage?: boolean;
}

const Examples: React.FC<IExamplesProps> = ({ type, examples, status, isLastMessage }) => {
   const { causesList } = useAppSelector(bonoBotState);

   let ExampleComponent: React.FC<any> | null = null;
   let example: CauseType | CharityExampleType | GeneralExampleType | number | undefined;

   if (type === 'general') {
      ExampleComponent = GeneralExample;
      if (examples.general?.title) {
         example = { ...examples.general, status } as GeneralExampleType;
      }
   } else if (type === 'cause') {
      ExampleComponent = CauseExample;
      const causeId = examples.cause?.id;
      example = causeId ? causesList.find((cause) => cause.id === causeId) : undefined;
   } else if (type === 'charity') {
      ExampleComponent = CharityExample;
      example = examples.charity?.id
         ? {
              ...examples.charity,
              shortDescription: examples.charity.shortDescription || '',
              active: examples.charity.active ?? true,
              isLastMessage,
           }
         : undefined;
      // const charityId = examples.charity?.id;
      // example = charityId ? charitiesList?.find((charity) => charity.id === charityId) : undefined;
   } else if (type === 'amount') {
      ExampleComponent = AmountExample;
      example = examples.amount;
   }

   if (!ExampleComponent || !example) {
      return null;
   }

   // Generate a unique key for the example
   const getExampleKey = () => {
      if (typeof example === 'number') {
         return `amount-example-${example}`;
      }
      if (example && 'title' in example) {
         return `general-example-${example.title}`;
      }
      return `example-${Date.now()}`;
   };

   const getExampleContainerSxProp = () => {
      if (type === 'charity' || type === 'amount')
         return { width: '100%', backgroundColor: 'unset', borderRadius: 0, border: 'none' };
      if (type === 'cause') return { width: '100%', backgroundColor: 'unset', borderRadius: 0, border: 'none' };
      return undefined;
   };

   return (
      <Box sx={{ width: '100%', pl: 5.25 }}>
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'row',
               columnGap: '6px',
               rowGap: '6px',
               flexWrap: 'wrap',
            }}
         >
            {example && (
               <ExampleContainer sxProp={getExampleContainerSxProp()} key={getExampleKey()}>
                  {ExampleComponent &&
                     (typeof example === 'number' ? (
                        <ExampleComponent amount={example} />
                     ) : (
                        <ExampleComponent {...example} />
                     ))}
               </ExampleContainer>
            )}
         </Box>
      </Box>
   );
};

export default Examples;
